import { useTranslation } from "react-i18next";
import { useDisclosure } from "@mantine/hooks";
import { CampaignQueryDataType } from "src/hooks/campaigns";

import { Section } from "../section";
import { AssignmentProductsDetail } from "./detail";

export interface AssignmentProductsProps {
    campaign: CampaignQueryDataType;
}

export const AssignmentProducts = ({ campaign }: AssignmentProductsProps) => {
    const { t } = useTranslation(["common"]);

    const [isCollapsed, { toggle: toggleCollapse }] = useDisclosure(false);

    return (
        <Section title={t("campaign_products")} isCollapsed={isCollapsed} onClick={toggleCollapse}>
            <AssignmentProductsDetail campaign={campaign} />
        </Section>
    );
};
